import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../../shared/components/notifications/notification.service';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmDialogComponent } from '../../../../shared/components/delete-confirm-dialog/delete-confirm-dialog.component';
import { TodoService } from '../../../../core/services/todo.service';
import { TodoForListing } from '../../../../core/models/todos/todo-for-listing.model';
import { TodoRequestFilter } from '../../../../core/models/todos/todo-request-filter.model';

@Component({
  selector: 'app-todo-list',
  standalone: false,
  templateUrl: './todo-list.component.html',
  styleUrl: './todo-list.component.css'
})



export class TodoListComponent implements OnInit {
  todos: TodoForListing[] = [];
  isLoading = false;

  currentPage = 0;
  pageSize = 10;
  totalItems = 0;

  searchTerm: string | undefined = undefined;

  constructor(
    private todoService: TodoService,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    const savedSearch = sessionStorage.getItem('todos.list.search');
    const savedPage = sessionStorage.getItem('todos.list.page');
    const savedPageSize = sessionStorage.getItem('todos.list.pageSize');

    this.searchTerm = savedSearch !== null ? (savedSearch || undefined) : this.searchTerm;
    this.currentPage = savedPage !== null ? parseInt(savedPage, 10) || 0 : this.currentPage;
    this.pageSize = savedPageSize !== null ? parseInt(savedPageSize, 10) || this.pageSize : this.pageSize;

    this.loadTodos();
  }

  loadTodos(): void {
    this.isLoading = true;
    const apiPage = this.currentPage + 1;

    const filter: TodoRequestFilter = {
      page: apiPage,
      pageSize: this.pageSize,
      ...(this.searchTerm !== undefined && { search: this.searchTerm })
    };

    this.todoService.getPaginatedTodos(filter).subscribe({
      next: ({ data, pagination }) => {
        this.todos = data;
        this.totalItems = pagination.totalItems;
        this.pageSize = pagination.itemsPerPage;
        this.currentPage = pagination.currentPage - 1;
        this.isLoading = false;
      },
      error: () => {
        this.notificationService.showError('Failed to load todos');
        this.isLoading = false;
      }
    });
  }

  onSearchChange(): void {
    this.currentPage = 0;
    sessionStorage.setItem('todos.list.search', this.searchTerm || '');
    sessionStorage.setItem('todos.list.page', this.currentPage.toString());
    sessionStorage.setItem('todos.list.pageSize', this.pageSize.toString());
    this.loadTodos();
  }

  clearSearch(): void {
    this.searchTerm = undefined;
    this.currentPage = 0;
    sessionStorage.removeItem('todos.list.search');
    sessionStorage.setItem('todos.list.page', this.currentPage.toString());
    sessionStorage.setItem('todos.list.pageSize', this.pageSize.toString());
    this.loadTodos();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    sessionStorage.setItem('todos.list.page', this.currentPage.toString());
    sessionStorage.setItem('todos.list.pageSize', this.pageSize.toString());
    this.loadTodos();
  }

  deleteTodo(id: number): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '400px',
      data: { itemName: 'this todo' }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.todoService.softDeleteTodo(id).subscribe({
          next: () => {
            this.notificationService.showSuccess('Todo deleted successfully');
            this.loadTodos();
          },
          error: () => this.notificationService.showError('Failed to delete todo')
        });
      }
    });
  }
}
